import { createSlice } from '@reduxjs/toolkit';

const localStorageContainer = createSlice({
  name: 'localStorageContainer',
  initialState: { data: {} },
  reducers: {
    setLocalStorageContainer(state, action) {
      state.data = action?.payload;
    },
    updateLocalStorageContainer(state, action) {
      state.data = { ...state.data, ...action.payload };
    },
    resetLocalStorageContainer(state) {
      state.data = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', (state) => {
      state.data = {};
    });
  },
});

export default localStorageContainer;
export const { setLocalStorageContainer, updateLocalStorageContainer, resetLocalStorageContainer } =
  localStorageContainer.actions;
